import React from 'react'
import CourierUsingApp from '../../assets/courier_usin_app.png'
import style from './style.module.css'
import { EmailVerifyTemplate } from '@components/EmailVerify'
import { APP_NAME } from '../../constants/app'
export const LoginApp = () => {
  return (
    <EmailVerifyTemplate>
      <img
        style={{ width: '150px', height: '150px' }}
        src={CourierUsingApp}
        alt="Courier Using App"
      />
      <h2 className={style.contentTitle}>Download our app to deliver</h2>
      <p className={style.contentDescription}>
        Get started by downloading our {APP_NAME} to your mobile device.
      </p>
    </EmailVerifyTemplate>
  )
}

export default LoginApp
